"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
function VideoStream(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.containPortrait, containPortrait = _c === void 0 ? false : _c, _d = _a.dataTestId, dataTestId = _d === void 0 ? 'video-stream' : _d, elementId = _a.elementId, _e = _a.hidden, hidden = _e === void 0 ? false : _e, mediaStream = _a.mediaStream, _f = _a.mirror, mirror = _f === void 0 ? false : _f, _g = _a.muted, muted = _g === void 0 ? false : _g, _h = _a.style, style = _h === void 0 ? {} : _h;
    var videoEl = react_1.useRef(null);
    var _j = react_1.useState(false), isPortrait = _j[0], setIsPortrait = _j[1]; // determined by examining the video element
    var composedStyles = __assign(__assign({}, style), { 
        // all of our layouts are based on landscape tiles which causes excessive cropping for remote portrait video when
        // the video area is 'cover'ed by the video, so use 'contain' for any portrait video and the existing setting for
        // landscape (usually 'cover' except for presentations)
        objectFit: containPortrait && isPortrait ? 'contain' : (style.objectFit || 'cover') });
    if (hidden) {
        composedStyles['opacity'] = 0;
    }
    if (mirror) {
        composedStyles['transform'] = 'rotateY(180deg)';
    }
    var handleVideoSizeUpdate = function () {
        var isUpdatePortrait = videoEl.current.videoHeight > videoEl.current.videoWidth;
        if (isUpdatePortrait !== isPortrait) {
            setIsPortrait(isUpdatePortrait);
        }
    };
    // safari fix hack
    react_1.useEffect(function () {
        var videoElementInterval = setInterval(function () {
            if (videoEl && videoEl.current && videoEl.current.ended) {
                // eslint-disable-next-line
                videoEl.current.srcObject = videoEl.current.srcObject;
            }
        }, 250);
        if (!!containPortrait) {
            videoEl.current.addEventListener('resize', handleVideoSizeUpdate);
            videoEl.current.addEventListener('loadedmetadata', handleVideoSizeUpdate);
        }
        // @ts-ignore
        return function cleanup() {
            if (videoElementInterval)
                clearInterval(videoElementInterval);
            if (!!containPortrait) {
                videoEl.current.removeEventListener('resize', handleVideoSizeUpdate);
                videoEl.current.removeEventListener('loadedmetadata', handleVideoSizeUpdate);
            }
        };
    }, []);
    react_1.useEffect(function () {
        if (videoEl.current && mediaStream) {
            videoEl.current.srcObject = mediaStream;
            videoEl.current.play();
        }
    }, [mediaStream]);
    return (react_1.default.createElement("video", { autoPlay: true, className: className, "data-testid": dataTestId, id: elementId, muted: muted, playsInline: true, ref: videoEl, style: composedStyles }));
}
exports.default = VideoStream;
